import { TextInput, TextInputArea, TextInputAreaProps, TextInputProps } from "@sg/ui";
import { forwardRef } from "react";
import { useIsOnboardingRole } from "~/hooks/util/useRoles";

export const RoleTextInput = forwardRef<HTMLInputElement, TextInputProps & { disabled?: boolean }>((props, ref) => {
  const canEdit = useIsOnboardingRole();
  const { disabled } = props;

  return <TextInput ref={ref} {...props} disabled={!canEdit || disabled} />;
});

export const RoleTextInputArea = forwardRef<HTMLTextAreaElement, TextInputAreaProps & { disabled?: boolean }>(
  (props, ref) => {
    const canEdit = useIsOnboardingRole();
    const { disabled } = props;

    return <TextInputArea ref={ref} {...props} disabled={!canEdit || disabled} />;
  }
);

RoleTextInput.displayName = "RoleTextInput";
RoleTextInputArea.displayName = "RoleTextInputArea";
